<script>
import { required, integer, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  name: 'custom-seat-form',
  props: {
    value: { type: Object, default: () => {} },
    submitLabel: { type: String, default: 'add to cart' },
    submitIcon: { type: String, default: 'bx bx-cart' }
  },

  data: vm => ({
    form: {
      specs: {
        date_delivery: null,
        foot_plate_width: null
      },
      reference: '',
      ...vm.value
    }
  }),

  methods: {
    reset () {
      this.form = {
        specs: {
          date_delivery: null,
          foot_plate_width: null
        },
        reference: '',
        comments: ''
      }
      this.$refs.wizard.reset()
    },
    onSaveHandler ($event, validate) {
      if (validate && typeof validate === 'function' && validate()) {
        this.$emit('complete', { ...this.form })
        this.reset()
      }
    },
    onCancel () {
      this.reset()
      this.$nextTick(() => {
        this.$emit('cancel')
      })
    }
  },
  computed: {
    steps () {
      let steps = [
        {
          id: 'form_basic_info',
          title: 'Basic Info',
          icon: 'bx bx-info-circle',
          component: () => import('./abs-thermo-specs'),
          active: true,
          validated: false
        },
        {
          id: 'comments',
          title: 'Comments',
          icon: 'bx bx-comment',
          component: () => import('../shared/comments'),
          active: false,
          validated: false
        },
        {
          id: 'shipping',
          title: 'Delivery Information',
          icon: 'bx bx-package',
          component: () => import('../shared/shipping'),
          active: false,
          validated: false
        }
      ]

      return steps
    }
  }
}
</script>
<template>
  <g-form-wizard :steps="steps" v-model="form" ref="wizard">
    <template
      v-slot:buttons="{
        isFirstStep,
        isLastStep,
        nextStep,
        previousStep,
        validateStep
      }"
    >
      <div
        class="d-flex justify-content-between align-items-center border-top pt-2"
      >
        <b-btn variant="link" class="mr-2" v-on:click="onCancel">
          Cancel
        </b-btn>

        <div class="d-flex justify-content-end w-100">
          <b-btn
            variant="link"
            class="mr-2 d-flex align-items-center"
            v-on:click="previousStep"
            :disabled="isFirstStep"
          >
            <i class="bx bx-left-arrow mr-2"></i>Back
          </b-btn>

          <b-btn
            variant="primary"
            class="btn-label mr-2"
            v-on:click="onSaveHandler($event, validateStep)"
            v-if="isLastStep"
          >
            <i class="label-icon" :class="[submitIcon]"></i>
            {{ $t(submitLabel) }}
          </b-btn>
          <b-btn
            variant="primary"
            class="mr-2 d-flex align-items-center"
            v-on:click="nextStep"
            v-else
          >
            Next<i class="bx bx-right-arrow ml-2"></i>
          </b-btn>
        </div>
      </div>
    </template>
  </g-form-wizard>
</template>
